const React = require("react");

module.exports = ({showError, error}) => showError ? (
  <div className="abs sb-15 sl">
    <span className="f11 cF00 fw4">
      {error || 'Invalid value'}
    </span>
  </div>
) : null;
